/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "File name is required" |
*
* @param {Spaces_File_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_name_required = /** @type {((inputs?: Spaces_File_Name_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Name_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiname ist erforderlich")
	return /** @type {LocalizedString} */ ("File name is required")
});